export const API_URL = ENVIRONMENT_VARIABLES?.apiUrl || '';

export const PROCESS_MANAGEMENT_API_APPENDIX = 'api/user-process-management';
export const TASK_MANAGEMENT_API_APPENDIX = 'api/user-task-management';
export const HISTORY_API_APPENDIX = 'api/history';
export const FORM_PROVIDER_API_APPENDIX = 'api/forms';
export const DOCUMENTS_MANAGEMENT_API_APPENDIX = 'documents';
export const EXCERPTS_API_APPENDIX = 'api/excerpts';
export const NOTIFICATIONS_API_APPENDIX = 'api/notifications';
